var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_6749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9894 15.407C23.8848 15.3027 23.7529 15.2302 23.6088 15.1979C23.4647 15.1655 23.3144 15.1746 23.1753 15.2242C21.306 15.8907 19.286 16.0131 17.35 15.5771C15.4139 15.1412 13.6413 14.1649 12.2381 12.7616C10.8349 11.3583 9.85865 9.58559 9.42283 7.64951C8.98702 5.71344 9.10951 3.69345 9.77608 1.82423C9.82561 1.6851 9.83469 1.53479 9.80228 1.39072C9.76986 1.24664 9.69728 1.11471 9.59294 1.0102C9.4886 0.905696 9.35677 0.832905 9.21275 0.800266C9.06873 0.767626 8.9184 0.776476 8.7792 0.825789C7.09396 1.4209 5.56462 2.38838 4.30498 3.65626C2.04687 5.91607 0.778693 8.98019 0.779297 12.1748C0.779901 15.3695 2.04924 18.4331 4.3082 20.6921C6.56716 22.9511 9.6308 24.2204 12.8255 24.221C16.0201 24.2216 19.0842 22.9534 21.344 20.6953C22.612 19.4355 23.5795 17.9058 24.1745 16.2203C24.2236 16.0811 24.2323 15.9308 24.1996 15.7869C24.1668 15.643 24.0939 15.5113 23.9894 15.407Z",
    fill: "#479FCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_6749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.b9370850cf715dea0156f35ce440a95e.svg";
export { ForwardRef as ReactComponent };